import styled from 'styled-components';
import colors from 'constants/colors';

export const Container = styled.div`
  display: flex;
  margin-bottom: 3px;
`;

export const RemoveContainer = styled.div`
  background-color: ${colors.charcoal};
  padding: 5px;
  width: 5%;
  display: flex;
  cursor: pointer;

  .delete {
    width: 14px;
    height: 14px;
    margin: auto;
  }

  .spinner {
    width: 20px;
    height: 20px;
    margin: auto;
  }
`;

export const ContentContainer = styled.div`
  background-color: ${colors.black5};
  padding: 5px 10px;
  width: ${(props) => props.disabled ? '100%' :'95%'};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

export const Header = styled.div`
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 0.5px;
  color: ${colors.white};

  @media only screen and (min-width: 767px) and (max-width: 1200px) {
    font-size: 15px;
  }

  @media only screen and (max-width: 767px) {
    font-size: 13px;
  }
`;

export const Content = styled.div`
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .description {
    color: ${colors.white};
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.5px;
    text-overflow: ellipsis;
  }

  .highlight {
    color: ${colors.lightBlue}
  }

  @media only screen and (min-width: 767px) and (max-width: 1200px) {
    font-size: 15px;
  }

  @media only screen and (max-width: 767px) {
    font-size: 13px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  background-color: ${colors.black5};
  justify-content: flex-end;
  align-items: center;
  width: 35%;
  height: 100%;
  padding: 10px;

  @media only screen and (min-width: 1200px) {
    .mobileButtonTitle {
      display: none;
    }
    .padButtonTitle {
      display: none;
    }
  }

  @media only screen and (min-width: 767px) and (max-width: 1200px) {
    .buttonTitle {
      display: none;
    }
    .mobileButtonTitle {
      display: none;
    }
  }

  @media only screen and (max-width: 767px) {
    .padButtonTitle {
      display: none;
    }
    .buttonTitle {
      display: none;
    }
  }
`;
